import http from "../http";


const WeatherMatrixService = {
    GetWeatherChart: async () => {
        const WeatherChart = await http.instance.get("/WeatherMatrix");
        return WeatherChart.data
    },

    SetWeatherPatch: async (id,data) => {
        const weather = await http.instance.post(`/WeatherMatrix/${id}`,data);
        return weather.data;
    },

    FirInsertOrUpdate : async (id, fir, regionName,IsDelete) =>{

        const WeatherRegion = {
            Id : id,
            FIR: fir,
            RegionName: regionName,
            IsDelete:IsDelete
        }


        const res = await http.instance.post('/WeatherMatrix/InsertOrUpdateFIR/', WeatherRegion);

        return res.data;
    },

    /*getSelectedFlight: async (id) => {
        const flight = await http.instance.get("/Schedule/GetNetlineFlightByKFNL/", {params: {FKeyForNetline: id}});
        return flight.data;
    },*/

    getWeatherRegions: async (id) => {
        const flight = await http.instance.get("/WeatherMatrix/GetWeatherRegions/", {params: {id: id}});
        return flight.data;
    },

    getWeatherChartTypes: async (id) => {
        const flight = await http.instance.get("/WeatherMatrix/GetWeatherChartTypes/", {params: {id: id}});
        return flight.data;
    },



};
export default WeatherMatrixService;
